import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Eye, EyeOff } from "lucide-react";
import { LOGO_URL } from "@/lib/brand";

export default function BrandLogin() {
  const { login, user, authReady } = useApp();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (authReady && user && user.role === "brand") nav("/brand"); }, [authReady, user, nav]);
  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "brand") { setErr("This login is for brand partners only."); return; }
      nav("/brand");
    } catch (e) { setErr(formatApiError(e.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center px-4 leaf-pattern">
      <div className="w-full max-w-md bg-cream rounded-[28px] soft-shadow-lg p-8">
        <div className="flex flex-col items-center mb-6">
          <img src={LOGO_URL} alt="LIVENEAT logo" className="h-40 w-auto object-contain mb-3" />
          <h1 className="font-heading text-3xl text-forest">Brand Portal</h1>
          <p className="text-sm text-brown/70">Sign in with the credentials shared by LIVENEAT</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="text-sm">Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="brand@company.com" className="rounded-xl bg-white" data-testid="brand-login-email" /></div>
          <div>
            <Label className="text-sm">Password</Label>
            <div className="relative">
              <Input type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-xl bg-white pr-11" data-testid="brand-login-password" />
              <button type="button" onClick={() => setShow((v) => !v)} className="absolute inset-y-0 right-0 flex items-center pr-3 text-brown/60 hover:text-forest" data-testid="brand-login-password-toggle">{show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}</button>
            </div>
          </div>
          {err && <p className="text-sm text-terracotta" data-testid="brand-login-error">{err}</p>}
          <Button type="submit" disabled={loading} className="w-full rounded-full h-12 bg-forest hover:bg-earth text-cream" data-testid="brand-login-submit">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}</Button>
        </form>
      </div>
    </div>
  );
}
